export default __webpack_public_path__ + "static/media/skoda-login.15320b1c.jpg";